import Vue from 'vue';

const END_POINT = '/expense';

const getExpense = (id) => Vue.axios.get(END_POINT + '/' + id);

const getAllExpenses = (data) => Vue.axios.get(END_POINT, { params: data });

const createExpense = (expense) => Vue.axios.post(END_POINT, expense);

const createAllExpenses = (Expenses) =>
  Vue.axios.post(END_POINT + '/all', Expenses);

const updateExpense = (expense) => Vue.axios.put(END_POINT, expense);

const deleteExpense = (id) => Vue.axios.delete(END_POINT + '/' + id);

export {
  getExpense,
  getAllExpenses,
  createExpense,
  createAllExpenses,
  updateExpense,
  deleteExpense,
};
